import { IFormatOption } from "../Format/FormatOption";

export class AnalyticsSearchCriteria {
    dateFrom?: string = '';
    dateTo?: string = null;
    searchString?: string = '';
    formats?: IFormatOption[] = [];
    parentOrganizationIds?: number[] = [];
    sortBy?: string = '';
    sortDesc?: boolean = true;
}